import { initialState } from "../groups.slice";

const resetGroups = () => {
    return initialState;
}

export default resetGroups;